module.exports = __webpack_public_path__ + "static/img/icon_crjc.3d84980b.png";